'use strict';

function controller (listingService, previousNextService) {
    const ctrl = this;

    ctrl.$onInit = handleOnInit;

    function handleOnInit () {
        listingService.getListing().then(listingResponse => {
            let { listingId } = listingResponse.listingDetailDto;

            ctrl.shouldShowPreviousNext = previousNextService.getVisibility();

            if (ctrl.shouldShowPreviousNext) {
                ctrl.lastListingSpot = previousNextService.getLastListingSpot();
                ctrl.currentListingSpot = previousNextService.getCurrentListingSpot(listingId);
                ctrl.previous = previousNextService.getPreviousConfig(listingId);
                ctrl.next = previousNextService.getNextConfig(listingId);
            }
        });
    }
}

controller.$inject = [
    'listingService',
    'previousNextService'
];

export default controller;
